<template>
    <TransitionRoot as="template" :show="modelValue">
        <Dialog as="div" class="relative z-50" @close="close">
            <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100"
                leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
                <div class="fixed inset-0 bg-gray-900/50 transition-opacity" />
            </TransitionChild>

            <div class="fixed inset-0 z-50 w-screen overflow-y-auto">
                <div class="flex min-h-full items-center justify-center p-4 text-center sm:p-6">
                    <TransitionChild as="template" enter="ease-out duration-300"
                        enter-from="translate-y-4 opacity-0 sm:translate-y-0 sm:scale-95"
                        enter-to="translate-y-0 opacity-100 sm:scale-100" leave="ease-in duration-200"
                        leave-from="translate-y-0 opacity-100 sm:scale-100"
                        leave-to="translate-y-4 opacity-0 sm:translate-y-0 sm:scale-95">
                        <DialogPanel
                            :class="['relative w-full transform overflow-hidden rounded-2xl bg-white p-6 text-left shadow-soft transition-all sm:my-8 sm:p-8', maxWidthClass]">
                            <button type="button"
                                class="absolute top-4 right-4 rounded-full p-1 text-gray-400 hover:bg-gray-100 hover:text-gray-600 focus:outline-none"
                                @click="close">
                                <span class="sr-only">Close</span>
                                <XMarkIcon class="size-5" aria-hidden="true" />
                            </button>
                            <DialogTitle v-if="title" as="h3" class="text-lg font-semibold text-gray-900">
                                {{ title }}
                            </DialogTitle>
                            <div :class="title ? 'mt-4' : ''">
                                <slot />
                            </div>
                        </DialogPanel>
                    </TransitionChild>
                </div>
            </div>
        </Dialog>
    </TransitionRoot>
</template>

<script setup>
import { computed } from 'vue';
import { Dialog, DialogPanel, DialogTitle, TransitionRoot, TransitionChild } from '@headlessui/vue';
import { XMarkIcon } from '@heroicons/vue/24/outline';

const props = defineProps({
    modelValue: { type: Boolean, default: false },
    title: { type: String, default: '' },
    maxWidth: { type: String, default: 'lg' },
});

const emit = defineEmits(['update:modelValue']);

const maxWidths = {
    sm: 'sm:max-w-sm',
    md: 'sm:max-w-md',
    lg: 'sm:max-w-lg',
    xl: 'sm:max-w-xl',
    '2xl': 'sm:max-w-2xl',
};

const maxWidthClass = computed(() => maxWidths[props.maxWidth] || maxWidths.lg);

const close = () => emit('update:modelValue', false);
</script>
